export const injectionNameClient = 'logger';
export const injectionNameGtm = 'gtmLogger';